import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert sx={{ fontSize: "1.4rem" }} elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AlertBar({ showAlert, handelCloseAlert, AlertMessage }) {
    return (
    <Snackbar open={showAlert} autoHideDuration={6000} onClose={handelCloseAlert}>
        <Alert onClose={handelCloseAlert} severity="success" sx={{
            width: '100%'
        }}>
            {AlertMessage}
        </Alert>
    </Snackbar>);
}
